export default __webpack_public_path__ + "static/nickAlmond-5dea7852552d4804e0696c7fd90cdfbd.jpg";